/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {interpolateTemplate} from '../filters/interpolate-template';

export interface BulkApiError {
  key: string;
  apiText: string;
}

export function bulkApiErrorsFromResponse(response: any): BulkApiError[] {
  let errors = _.get(response, ['data', 'errors']);
  if (_.isNil(errors)) {
    const responseData = _.get(response, 'data');
    if (_.isArray(responseData) || _.get(responseData, 'error') || _.get(responseData, 'code') || _.get(responseData, 'text')) {
      errors = responseData;
    }
  }
  errors = _.isArray(errors) ? errors : (_.isNil(errors) ? [] : [errors]);

  const apiErrors = _.map(errors, (err: any) => {
    const errorInfo = _.get(err, 'error') || err || {};
    const text = _.isString(errorInfo)
      ? errorInfo
      : errorInfo.text || errorInfo.message || errorInfo.code;
    return {
      key: errorInfo.code || 'bulk.update.failed',
      apiText: text ? interpolateTemplate(text)(errorInfo.parameters) : 'The bulk update could not be applied.'
    };
  });

  if (!apiErrors.length) {
    apiErrors.push({
      key: 'bulk.update.failed',
      apiText: _.get(response, ['data', 'message']) || response?.statusText || 'The bulk update could not be applied.'
    });
  }
  return apiErrors;
}
